<template>
  <div>
    <my-menu menu-name="home"></my-menu>

    <div class="banner">
      <img class="bg" src="../assets/images/teacher-header.png" />
      <div class="wrapper">
        <div class="switch">
          <router-link to="/" class="">教师端</router-link>
          <router-link to="/student" class="switch-active">学生端</router-link>
        </div>
        <div class="inner">
          <p class="text_weici">维词教师版</p>
          <p class="text_slogan">让你的英语教学更精彩</p>
          <div class="product_list">
            <a href="https://bsource.weicistudy.com/pc_download/weici_setup_win.exe" target="_blank" class="product_item">
              <img src="../assets/images/pc.png"/>
              <div class="product_des">
                <p>点击下载</p>
                <p>高中维词教学系统</p>
                <p>（PC客户端）</p>
              </div>
            </a>
            <a href="https://bsource.weicistudy.com/pc_download/weici_setup_mac.dmg" target="_blank" class="product_item">
              <img src="../assets/images/mac.png"/>
              <div class="product_des">
                <p>点击下载</p>
                <p>高中维词教学系统</p>
                <p>（MAC客户端）</p>
              </div>
            </a>
            <div class="product_item">
              <img src="../assets/images/mqrcodes.png"/>
              <div class="product_des">
                <p>扫码下载</p>
                <p>高中维词教师版</p>
                <p>APP移动端</p>
              </div>
            </div>
          </div>
          <!--<img class="qrcode" src="../assets/images/gzqrcodet.png" />-->
          <!--<p class="text_download">扫描下载APP</p>-->
        </div>
        <div class="download">
          <!--<router-link :to="{name: 'Download'}"><img src="../assets/images/ios.png" /></router-link>-->
          <a href="https://itunes.apple.com/cn/app/%E7%BB%B4%E8%AF%8D%E6%95%99%E5%B8%88%E7%89%88/id1354318280?mt=8" target="_blank"><img src="../assets/images/ios.png" /></a>
          <div class="line"></div>
          <a href="http://a.app.qq.com/o/simple.jsp?pkgname=com.android.weici.senior.teacher" target="_blank"><img src="../assets/images/ad.png" /></a>
          <!--<router-link :to="{name: 'Download'}"><img src="../assets/images/ad.png" /></router-link>-->
        </div>
      </div>
    </div>

    <section class="content">
      <div class="text">
        <p>维词教师版是一款</p>
        <p>为高中英语老师精心准备的教学辅助工具</p>
        <p>内容融入英语教学各个场景  为学生英语学习提供帮助</p>
        <p>WEICI App (Teacher's Edition) </p>
        <p>is specially designed as an effective tool</p>
        <p>for High School English teachers to help their students improve scores.</p>
      </div>
      <div class="arrow">
        <img src="../assets/images/arrow.png" />
      </div>
      <div class="card">
        <ul>
          <li>
            <div class="card_text">
              <p class="title">精选优质内容</p>
              <p class="title">给老师赋能</p>
              <p>大数据标注历年考点，多维度精讲词汇</p>
              <p>专业教学设计，精准同步教材</p>
              <p>优质课件、影音词汇讲解，备课资源丰富 </p>
            </div>
            <div class="img_right">
              <img v-lazy="'/static/images/home/5.png'" />
            </div>
          </li>
          <li>
            <div class="img_left">
              <img v-lazy="'/static/images/home/6.png'" />
            </div>
            <div class="card_text right">
              <p class="title">智能分析</p>
              <p class="title">帮学生查漏补缺</p>
              <p>精选题库、多种题型，一键布置作业</p>
              <p>大数据智能分析，检查作业更轻松</p>
              <p>分层教学，真正实现因材施教</p>
            </div>
          </li>
          <li>
            <div class="card_text">
              <p class="title">融入教学场景</p>
              <p class="title">为老师赋能</p>
              <p>课前预习，讲课更轻松</p>
              <p>课上多种教学方式，激发学生英语学习兴趣</p>
              <p>课后巩固、查漏补缺，培养学生好习惯</p>
            </div>
            <div class="img_right">
              <img v-lazy="'/static/images/home/7.png'" />
            </div>
          </li>
<!--          <li>-->
<!--            <div class="img_left">-->
<!--              <img v-lazy="'/static/images/home/8.png'" />-->
<!--            </div>-->
<!--            <div class="card_text right">-->
<!--              <p class="title">千所学校深度使用</p>-->
<!--              <p class="title">百强名校强烈推荐</p>-->
<!--              <p>覆盖30个省，千所学校常态化使用</p>-->
<!--              <p>中国百强名校老师强烈推荐</p>-->
<!--              <p>减负增效，英语教学好帮手</p>-->
<!--            </div>-->
<!--          </li>-->
        </ul>
      </div>
       <!-- v-lazy:background-image="'../../../static/images/gzm2.png'" -->
<!--      <div class="ex_school">-->
<!--        <img v-lazy="'/static/images/gzm3.png'" style="width:100%;" />-->
<!--        <div class="ex_content">-->
<!--          <p>教学场景全覆盖 效率更高</p>-->
<!--          <p>千所学校深度使用，百强名校强烈推荐</p>-->
<!--          <p>It fully covers teaching scenes and makes teaching more efficient.</p>-->
<!--          <p>It is heavily used by 1,000 schools and highly recommended by Top 100 schools.</p>-->
<!--        </div>-->
<!--        <div class="clear"></div>-->
<!--      </div>-->
<!--      <div class="stu_list">-->
<!--        <ul>-->
<!--          <li>-->
<!--            <div class="thumb" style="width: 290px;height: 350px;">-->
<!--              <img v-lazy="'/static/images/t1.png'" />-->
<!--              <div class="caption">-->
<!--                  <p>维词教师版作业布置、检测，提供学情数据反馈，让我能清楚了解学生的掌握情况，优化课堂教学，让我们老师真正做到因材施教。</p>-->
<!--                  <p style="text-align:right;font-size: 13px">山东省潍坊一中&nbsp;英语教研组长&nbsp;王春成</p>-->
<!--              </div>-->
<!--            </div>-->
<!--          </li>-->
<!--          <li>-->
<!--            <div class="thumb" style="width: 290px;height: 350px;">-->
<!--              <img v-lazy="'/static/images/t2.png'" />-->
<!--              <div class="caption">-->
<!--                <p>维词教师版，教研团队提供了丰富的教学资源，学习课件新颖独特，真正的解决了一线教学的实际需求，是我们英语教学很好的辅助工具。</p>-->
<!--                <p style="text-align:right;font-size: 13px">河北省石家庄实验中学&nbsp;英语教研组长&nbsp;李霞</p>-->
<!--              </div>-->
<!--            </div>-->
<!--          </li>-->
<!--          <li>-->
<!--            <div class="thumb" style="width: 290px;height: 350px;">-->
<!--              <img v-lazy="'/static/images/t3.png'" />-->
<!--              <div class="caption">-->
<!--                <p>维词课堂、影视单词学习，给我们提供丰富的课堂教学资源，学生作业大数据的分析，为我们老师提供了科学，准确、详实的教学反馈，让我们的课堂教学更高效。</p>-->
<!--                <p style="text-align:right;font-size: 13px">山东省济宁育才中学&nbsp;英语教研组长&nbsp;郭晓辉</p>-->
<!--              </div>-->
<!--            </div>-->
<!--          </li>-->
<!--        </ul>-->
<!--        <div class="clear"></div>-->
<!--      </div>-->
    </section>

    <my-footer></my-footer>
  </div>
</template>

<script>
  import MyFooter from '@/components/Footer'
  import MyMenu from '@/components/Menu'

  export default {
    data () {
      return {
      }
    },
    components: {
      MyFooter,
      MyMenu
    },
    methods: {

    }
  }
</script>

<style scoped>

  .product_list {
    margin-top: 50px;
  }

  .product_list .product_item {
    display: inline-block;
    font-size: 24px;
    color: #FFFFFF;
    margin-left: 30px;
  }

  .product_list .product_item:last-child {
    /*margin-left: 100px;*/
  }

  .product_list .product_item .product_des {
  }

  .product_list .product_item .product_des p {
    margin: 10px 0;
  }
</style>



// WEBPACK FOOTER //
// Teacher.vue?2200d025